// extracted by mini-css-extract-plugin
export default {"addressAndPrice":"styles_addressAndPrice__cm9Ni","price":"styles_price__XcBTT"};